import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import TeacherComponent from './components/TeacherComponent';

const MyTeacher = () => {
  return renderComponent(<TeacherComponent />);
};

export default MyTeacher;
